import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { PlainImageComponent } from '../../../app/components/plain-image/plain-image.component';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { TeaserCardSection } from '../../../app/components/teaser-card/teaser-card.component';
import { Section, SectionAttributes } from '../../../app/types/section';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type CardCollectionSection = Section<
  {
    numColumns: 12;
    headline: string;
    cards: TeaserCardSection[];
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
  ],
  'card-collection'
>;

@Component({
  selector: 'app-card-collection',
  styleUrls: ['./card-collection.component.scss'],
  templateUrl: './card-collection.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    PlainImageComponent,
    CardComponent,
    StandaloneLinkComponent,
    RouterOrExternalLinkDirective,
    FsButtonComponent,
],
})
export class CardCollectionComponent extends SectionComponent<CardCollectionSection> {
}
